import { RECEIVE_WALLET_IMG_PATH, SEND_WALLET_IMG_PATH } from '@/consts/imgPath';
import * as ViewModel from '@/core/presenter/viewModel';
import clsx from 'clsx';
import { useCallback } from 'react';

interface IProps {
  transaction: ViewModel.IResponseActivity;
  myTrxAddress: string;
  onClickResendBtn: () => void;
  onClickTrxAddressCopyBtn: (text: string) => void;
}

const MemoArea = ({ transaction, myTrxAddress, onClickResendBtn, onClickTrxAddressCopyBtn }: IProps) => {
  const handleClickCopyBtn = useCallback(() => {
    onClickTrxAddressCopyBtn(transaction.type === '보내기' ? transaction.to : transaction.from);
  }, [transaction.from, transaction.to, transaction.type, onClickTrxAddressCopyBtn]);

  return (
    <div className="memo-area">
      {transaction.type === '보내기' && (
        <div className="inner">
          <div className="left-right-wrap">
            <div className="left">
              <div
                className={clsx('address-highlighter', {
                  hightlight_my_trx_address: transaction.from_short === myTrxAddress,
                })}
              >
                <div className="img">
                  <img src={SEND_WALLET_IMG_PATH} alt="wallet-img" />
                </div>
                <p className="memo-font">{transaction.from_short}</p>
              </div>
              {transaction.to_memo.length > 0 && <span className="body-xs memo-font">나</span>}
            </div>
            <div className="divisor-img">
              <img src="img/divisor.png" alt="divisor" />
            </div>
            <div className="right">
              <div className="address-highlighter">
                <div className="img">
                  <img src={RECEIVE_WALLET_IMG_PATH} alt="wallet-img2" />
                </div>
                <p className="memo-font">{transaction.to_short}</p>
                <i className="bi bi-files pointer_cursor" onClick={handleClickCopyBtn}></i>
              </div>
              <span className="body-xs memo-font">
                {transaction.type === '보내기' ? transaction.to_memo : transaction.from_memo}
              </span>
            </div>
          </div>
          <button className="memo-button body-xs fw-b asset-bot-button memo-font">
            <a href="#" onClick={onClickResendBtn}>
              {transaction.to_memo.length > 0
                ? `${transaction.to_memo}에게 보내기`
                : `${transaction.to_short}에게 보내기`}
            </a>
          </button>
        </div>
      )}

      {transaction.type === '받기' && (
        <div className="inner">
          <div className="left-right-wrap">
            <div className="left">
              <div className="address-highlighter">
                <div className="img">
                  <img src={SEND_WALLET_IMG_PATH} alt="wallet-img" />
                </div>
                <p className="memo-font">{transaction.from_short}</p>
                <i className="bi bi-files pointer_cursor" onClick={handleClickCopyBtn}></i>
              </div>
              <span className="body-xs memo-font">
                {transaction.type === '받기' ? transaction.from_memo : transaction.to_memo}
              </span>
            </div>

            <div className="divisor-img">
              <img src="img/divisor.png" alt="divisor" />
            </div>

            <div className="right">
              <div
                className={clsx('address-highlighter', {
                  hightlight_my_trx_address: transaction.to_short === myTrxAddress,
                })}
              >
                <div className="img">
                  <img src={RECEIVE_WALLET_IMG_PATH} alt="wallet-img2" />
                </div>
                <p className="memo-font">{transaction.to_short}</p>
              </div>
              {transaction.from_memo.length > 0 && <span className="body-xs memo-font">나</span>}
            </div>
          </div>

          <button className="memo-button body-xs fw-b asset-bot-button memo-font">
            <a href="#" onClick={onClickResendBtn}>
              {transaction.from_memo.length > 0
                ? `${transaction.from_memo}에게 보내기`
                : `${transaction.from_short}에게 보내기`}
            </a>
          </button>
        </div>
      )}
    </div>
  );
};

export default MemoArea;
